import React from 'react';

export interface AgentConfig {
  id: string;
  component: React.ComponentType<any>;
  label: string;
  description?: string;
  icon?: string;
  flag?: string;
}

class AgentRegistry {
  private agents = new Map<string, AgentConfig>();

  register(agent: AgentConfig): void {
    this.agents.set(agent.id, agent);
  }

  get(id: string): AgentConfig | undefined {
    return this.agents.get(id);
  }

  getAll(): AgentConfig[] {
    return Array.from(this.agents.values());
  }

  has(id: string): boolean {
    return this.agents.has(id);
  }
}

export const agentRegistry = new AgentRegistry();
